export const isNetworkError = error => {
  if (error) {
    return error.message === 'Failed to fetch'
  } else {
    return false
  }
}
